/**
 * Checks if the provided search data includes the 'visualNavigation' template and has a PLP banner.
 * @param {Object} searchData - The search data object to check.
 * @param {boolean} [isB2B=false] - Whether the current storefront experience is B2B.
 * @param {string} [experienceType=''] - Experience type (for example, `'ma'`) used
 * @returns {boolean} Returns true if the conditions are met, otherwise false.
 */
export const isEtchVisNavOnPLP = (searchData, isB2B = false, experienceType = '') => {
  try {
    if (searchData === null || searchData === undefined || Object.keys(searchData).length === 0) {
      return false;
    }
    const stringifiedPartialTemplates = searchData?.searchModel?.partialTemplates;
    const etchVisualNavExists = (stringifiedPartialTemplates?.[0] || '').indexOf('visualNavigation') > -1;
    const hasPLPBanner = searchData?.searchModel?.metadata?.hasPLPBanner;
    const isPLPPage = searchData?.searchModel?.metadata?.contentType === 'plppage';

    if (experienceType === 'ma' && !isB2B) {
      const firstTemplateString = stringifiedPartialTemplates?.[0];
      if (!firstTemplateString) {
        return false;
      }
      const firstTemplate = JSON.parse(firstTemplateString);
      const plpBanner = firstTemplate?.PLP_Banner;
      return (!!plpBanner && plpBanner?.Content?.length > 0) && etchVisualNavExists && isPLPPage;
    }

    return hasPLPBanner && etchVisualNavExists && isPLPPage;
  } catch (err) {
    // eslint-disable-next-line no-console
    return false;
  }
};
